import React from "react";
import {BootstrapTable} from "react-bootstrap-table";
import 'react-bootstrap-table/dist//react-bootstrap-table-all.min.css';
import DataTableComponent from "./DataTableComponent";

const DEFAULT_PAGE_SIZE = 10;
const DEFAULT_PAGE_NUMBER = 1;

const stateCache = {};
const getStateKey = function (tableKey="") {
  let href = window.location.href;
  href = href.replace("#", "");
  return href + "" + tableKey;
};
const saveState = (stateKey, state) => {
  stateCache[stateKey] = {...state};
};
const getState = (stateKey) => {
  return stateCache[stateKey];
};

export default class CustomPaginatedDataTableComponent extends React.Component {

  constructor(props) {
    super(props);
    if (props.onRef) {
      props.onRef(this);
    }

    this.enableSortByDefault = false;
    this.keyColumnDataField = props.tableColumnConfig[0].dataField;

    this.options = DataTableComponent.getStandardOptions(props);
    this.autoRefresh = props.autoRefresh || false;
    this.refreshInterval = props.refreshInterval || 30000;
    this.reloadData = props.reloadData;

    this.options.onPageChange = this.onPageChange.bind(this);
    this.options.paginationShowsTotal = DataTableComponent.getPaginationTotalFunction();
    this.options.toolBar = DataTableComponent.getToolbarFunction(this.props.hideToolBar, this.props.createSearchGroup);
    this.options.btnGroup = DataTableComponent.getButtonGroupFunction(this.props.createCustomButtonGroup);


    this.stateKey = getStateKey(this.props.tableCacheKey);
    let restoreState = getState(this.stateKey);
    if (restoreState) {
      this.state = restoreState;
    } else {

      let sortName = undefined;
      let sortOrder = undefined;
      let sortKey = "";
      let sortKeyOrder = "";


      if (this.props.defaultSort !== undefined) {
        sortName = this.props.defaultSort.sortBy;
        sortOrder = this.props.defaultSort.sortOrder.toLowerCase();

        sortKey = this.findSortKey(sortName);
        sortKeyOrder = sortOrder.toUpperCase();
      }
      this.state = {
        buttonStates: {},
        pageNumber: DEFAULT_PAGE_NUMBER,
        pageSize: this.props.defaultPageSize || DEFAULT_PAGE_SIZE,
        oldPageSize: DEFAULT_PAGE_SIZE,
        totalRecords: props.totalRecords,
        sortName: sortName,
        sortOrder: sortOrder,
        sortKey: sortKey,
        sortKeyOrder: sortKeyOrder
      };
    }

    if(this.autoRefresh) {
      this.timerId = setInterval(this.reloadData, this.refreshInterval);
    }

    this.getButtonState = this.getButtonState.bind(this);
    this.onSortChange = this.onSortChange.bind(this);
    this.onHeadersChange = this.onHeadersChange.bind(this);
  }

  componentWillUnmount() {
    if (this.stateKey) {
      saveState(this.stateKey, this.state);
    }
    if(this.timerId) {
      clearInterval(this.timerId);
    }
  }

  getHeaders() {
    return {
      "X-page-number": this.state.pageNumber,
      "X-page-size": this.state.pageSize,
      "X-sort-by": [this.state.sortKey],
      "X-sort-order": [this.state.sortKeyOrder]
    };
  }

  resetPage(callback) {
    this.setState({
      pageNumber: 1
    }, callback);
  }

  onHeadersChange() {
    if (this.props.onHeadersChange) this.props.onHeadersChange();
  }

  onPageChange(page, sizePerPage) {
    if (this.state.oldPageSize !== sizePerPage) {
      page = 1;
    }

    this.setState({
      oldPageSize: sizePerPage,
      pageSize: sizePerPage,
      pageNumber: page
    }, this.onHeadersChange);
  }

  onSortChange(sortName, sortOrder) {
    let sortKey = this.findSortKey(sortName);
    let sortKeyOrder = (sortOrder !== undefined) ? sortOrder.toUpperCase() : "";

    this.setState({
      sortKey,
      sortKeyOrder,
      sortName,
      sortOrder
    }, this.onHeadersChange);
  }

  findSortKey(sortName) {
    let configEntry = null;

    this.props.tableColumnConfig.forEach(config => {
      if (config.dataField === sortName) {
        configEntry = config;
      }
    });

    if (configEntry === null) return undefined;

    let sortKey = (configEntry.sortKey !== undefined) ? configEntry.sortKey : configEntry.dataField;
    return sortKey;
  }

  getButtonState(key, id) {
    return this.state.buttonStates
      && this.state.buttonStates[key]
      && this.state.buttonStates[key].indexOf(id) >= 0;
  }

  setButtonState(key, id, value) {
    let buttonStates = this.state.buttonStates || {};
    let buttonStatesForKey = buttonStates[key] || [];
    let index = buttonStatesForKey.indexOf(id);

    if (value === true) {
      if (index < 0)
        buttonStatesForKey.push(id);
    } else {
      buttonStatesForKey.splice(index, 1);
    }
    buttonStates[key] = buttonStatesForKey;
    this.setState({
      buttonStates: buttonStates
    });
  }

  getData() {
    if (!Array.isArray(this.props.tableData)) {
      return [];
    }
    return this.props.tableData;
  }

  render() {
    return <BootstrapTable
      className={"sfx-data-table"}
      ref={'table'}
      striped={true}
      hover={false}
      pagination={this.props.pagination === undefined ? true : this.props.pagination}
      condensed
      search={false}
      version="4"
      data={this.getData()}
      selectRow={this.onSelectRow}
      expandableRow={this.props.isExpandableRow || undefined}
      expandComponent={this.props.getExpandableComponent || undefined}
      exportCSV={this.props.exportCSV}
      remote={true}
      fetchInfo={
        {
          dataTotalSize: this.props.totalRecords,
        }

      }
      options={{
        ...this.options,
        page: this.state.pageNumber,
        pageNumber: this.state.pageNumber,
        pageSize: this.state.pageSize,
        sizePerPage: this.state.pageSize,
        onSortChange: this.onSortChange,
        sortName: this.state.sortName,
        sortOrder: this.state.sortOrder
      }}
    >
      {
        this.props.tableColumnConfig.map((column, index) => {
          return DataTableComponent.createColumn(column, index, this);
        })
      }
    </BootstrapTable>;

  }
}
